export default {
  'SentimentChartTooltip.positive': 'Позитивные',
  'SentimentChartTooltip.negative': 'Негативные',
  'SentimentChartTooltip.neutral': 'Нейтральные',
}
